var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVixco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 45,
    viewBox: "0 0 132 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.400391,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FAF8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5144 12.8711L25.6586 32.8444H18.2734L25.6038 19.3592C26.6376 17.4571 28.1507 15.8583 29.9931 14.7214C31.8354 13.5846 33.943 12.9492 36.1067 12.8784C36.2414 12.8742 36.3788 12.8711 36.5144 12.8711Z",
    fill: "url(#paint0_linear_1148_4636)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.56934 12.8711L17.4252 32.8444H24.8103L17.4797 19.3592C16.446 17.457 14.9328 15.8582 13.0904 14.7214C11.248 13.5846 9.14043 12.9492 6.97669 12.8784C6.84236 12.8742 6.70494 12.8711 6.56934 12.8711Z",
    fill: "url(#paint1_linear_1148_4636)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1241 11.8644L60.7113 21.3684C61.3185 23.586 61.7145 25.4604 62.3481 27.678H62.4801C63.0873 25.4604 63.5361 23.586 64.1433 21.3684L66.6777 11.8644H70.6377L64.6449 31.4004H59.9985L54.0321 11.8644H58.1241ZM76.7932 11.8644V31.4004H72.886V11.8644H76.7932ZM79.9105 11.8644H84.2401L86.1937 15.8772C86.6425 16.8012 87.0385 17.7252 87.6457 18.966H87.7777C88.2793 17.7252 88.6489 16.8012 89.0713 15.8772L90.9193 11.8644H95.0377L89.8897 21.5004L95.3809 31.4004H91.0513L88.8601 27.0708C88.3585 26.0412 87.9361 25.038 87.3289 23.85H87.2233C86.7217 25.038 86.2993 26.0412 85.7977 27.0708L83.7121 31.4004H79.5673L85.0585 21.3156L79.9105 11.8644ZM105.377 31.77C100.414 31.77 96.4272 28.2324 96.4272 21.7116C96.4272 15.27 100.572 11.4948 105.509 11.4948C108.043 11.4948 109.97 12.6564 111.238 14.0028L109.178 16.4844C108.202 15.534 107.066 14.8476 105.588 14.8476C102.631 14.8476 100.414 17.382 100.414 21.5796C100.414 25.83 102.42 28.3908 105.509 28.3908C107.198 28.3908 108.492 27.5988 109.548 26.4636L111.607 28.8924C109.997 30.8196 107.938 31.77 105.377 31.77ZM121.485 31.77C116.311 31.77 112.747 27.8892 112.747 21.5532C112.747 15.1908 116.311 11.4948 121.485 11.4948C126.659 11.4948 130.223 15.2172 130.223 21.5532C130.223 27.8892 126.659 31.77 121.485 31.77ZM121.485 28.3908C124.389 28.3908 126.237 25.698 126.237 21.5532C126.237 17.3028 124.468 14.8476 121.485 14.8476C118.502 14.8476 116.733 17.3028 116.733 21.5532C116.733 25.698 118.581 28.3908 121.485 28.3908Z",
    fill: "#3F3F46"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1148_4636",
    x1: 33.7965,
    y1: 10.9137,
    x2: 19.8126,
    y2: 32.6739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78C8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19B9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1148_4636",
    x1: 9.28724,
    y1: 10.9137,
    x2: 23.2711,
    y2: 32.6739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78C8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19B9EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVixco);
export default __webpack_public_path__ + "static/media/logo_vixco.01ee18b1d5f16bca964dba84e9b1f26e.svg";
export { ForwardRef as ReactComponent };